import { useParams } from 'react-router-dom'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useLazyRef } from 'modules/core/hooks/useLazyRef'

import contractVersions from 'modules/contracts/store/collections/contractVersions'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import UpdatePolicySectionForm from 'modules/payroll_bundle/components/settings/UpdatePolicySectionForm'
import PayrollPaywallGuard from 'modules/payroll_bundle/pages/PayrollPaywallGuard'
import EmployeesPage from 'modules/payroll_bundle/pages/settings/PolicySettingsPage/EmployeesPage'
import { Policies } from 'modules/payroll_bundle/store/collections/policies'

const PolicySettingsPage = () => {
  const params = useParams()

  const policyCollection = useLazyRef<Policies>(() => new Policies()).current
  const policy = policyCollection.get(Number(params.policyId))

  const { loading } = useAsyncData(
    () =>
      Promise.all([
        contractVersions.fetch({ withCachedFetchParams: true }),
        policyCollection.fetch({ data: { id: params.policyId } }),
      ]),
    []
  )

  return (
    <PayrollPaywallGuard>
      <ResponsivePage.Body showHeader={false} loading={loading} error={null} authorized={!!policy}>
        {!!policy && <UpdatePolicySectionForm policy={policy} />}
        <EmployeesPage contractVersions={contractVersions} />
      </ResponsivePage.Body>
    </PayrollPaywallGuard>
  )
}

export default PolicySettingsPage
